import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { ComponentLayoutModel } from '../../Models/ComponentLayoutModel';
import LayoutInputContent from './LayoutInputContent';
import { LayoutInputDialog } from './LayoutInputDialog';

type LayoutInputProps = {
	layout: ComponentLayoutModel | undefined;
	onLayoutChange: (layout: ComponentLayoutModel | undefined) => void;
};

export default function LayoutInput({ layout, onLayoutChange }: LayoutInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={layout} onValueChange={onLayoutChange} onOpen={() => setOpen(true)}>
			<LayoutInputContent value={layout} />
			{open && <LayoutInputDialog open={open} setOpen={setOpen} layout={layout} onLayoutChange={onLayoutChange} />}
		</GenericPropertyInput>
	);
}
